import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

// Polls rather than pushes — no realtime transport (websockets/SSE) is wired
// up for this endpoint yet, so a short interval is the simplest way to
// surface new invitations without a manual refresh.
const POLL_INTERVAL_MS = 30_000;

export const useNotifications = () => {
  return useQuery({
    queryKey: QUERY_KEYS.notifications,
    queryFn: () => container.notifications.list(),
    refetchInterval: POLL_INTERVAL_MS,
  });
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => container.notifications.markRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications }),
  });
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => container.notifications.markAllRead(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications }),
  });
};
